<script setup lang="ts">
import type { SituationAnswer } from '../revalidationsShared.types'

defineProps<{
  questionId: string
  question: string
}>()

const modelValue = defineModel<SituationAnswer>({ required: true })
</script>

<template>
  <div class="revalidation-yes-no-toggle">
    <span :id="questionId" class="revalidation-yes-no-toggle__question">{{ question }}</span>
    <div
      class="revalidation-yes-no-toggle__buttons"
      role="group"
      :aria-labelledby="questionId"
    >
      <button
        type="button"
        class="revalidation-yes-no-toggle__btn"
        :class="{ 'revalidation-yes-no-toggle__btn--no-active': modelValue === 'no' }"
        :aria-pressed="modelValue === 'no'"
        @click="modelValue = 'no'"
      >
        Não
      </button>
      <button
        type="button"
        class="revalidation-yes-no-toggle__btn"
        :class="{ 'revalidation-yes-no-toggle__btn--yes-active': modelValue === 'yes' }"
        :aria-pressed="modelValue === 'yes'"
        @click="modelValue = 'yes'"
      >
        Sim
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.revalidation-yes-no-toggle {
  @apply flex flex-row flex-wrap items-center justify-between gap-4;
  @apply min-h-12 px-4 py-4;

  .revalidation-yes-no-toggle__question {
    @apply fonts-body-medium-bold text-neutral-low-pure leading-[1.375];
    @apply flex-1 min-w-48 pr-2;
  }

  .revalidation-yes-no-toggle__buttons {
    @apply inline-flex flex-row items-stretch flex-shrink-0 overflow-hidden rounded-md;
    @apply border border-neutral-high-medium bg-neutral-high-pure;

    .revalidation-yes-no-toggle__btn {
      box-sizing: border-box;
      @apply flex items-center justify-center w-16 h-9 border-0 m-0;
      @apply fonts-body-medium-bold text-neutral-low-pure;
      @apply bg-neutral-high-pure cursor-pointer transition-colors duration-150 ease-out;

      &:not(:last-child) {
        @apply border-r border-neutral-high-medium;
      }

      &:focus-visible {
        outline: 2px solid theme('colors.brand.primary.pure');
        outline-offset: 2px;
        z-index: 1;
      }

      &--no-active {
        @apply bg-feedback-negative-pure text-neutral-high-pure;

        &:not(:last-child) {
          border-right-color: transparent;
        }
      }

      &--yes-active {
        @apply bg-feedback-positive-pure text-neutral-high-pure;
      }
    }
  }
}
</style>
